export default __webpack_public_path__ + "static/media/cloudUpload.5549f2a2.svg";